// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"64c87088","199":"7b902ed9"}[chunkId] + ".chunk.js";
};